import { getInvoiceLinkMockHandler } from '@/features/onboarding/components/step-tracker/api/invoice-link';

export const invoiceLinkHandlers = [getInvoiceLinkMockHandler];
